<nz-breadcrumb class="font-size-16">
  <!-- <nz-breadcrumb-item>
    <a (click)="home()">首页</a>
  </nz-breadcrumb-item> -->
  <nz-breadcrumb-item *ngIf="navigation?.title">
    <a (click)="backtrack(navigation)">{{navigation.title}}</a>
  </nz-breadcrumb-item>
  <nz-breadcrumb-item *ngIf="lucaTitle03">
    <span class="p-display-inline-block" [innerHtml]="lucaTitle03 | safeHtml"></span>
  </nz-breadcrumb-item>
  <nz-breadcrumb-item *ngIf="lucaTitle02">
    <span class="p-display-inline-block" [innerHtml]="lucaTitle02 | safeHtml"></span>
  </nz-breadcrumb-item>
  <nz-breadcrumb-item *ngIf="lucaTitle01">
    <span class="p-display-inline-block" [innerHtml]="lucaTitle01 | safeHtml"></span>
  </nz-breadcrumb-item>
  <nz-breadcrumb-item *ngIf="elderTitle">
    <span class="p-display-inline-block" [innerHtml]="elderTitle | safeHtml"></span>
  </nz-breadcrumb-item>
  <nz-breadcrumb-item *ngIf="title">
    <span class="p-display-inline-block" [innerHtml]="title | safeHtml"></span>
  </nz-breadcrumb-item>
</nz-breadcrumb>